import type { RouteObject } from "react-router-dom";
import AppLayout from "@/pages/layout";
import TabRouteWrapper from "@/components/feature/TabRouteWrapper";
import NotFound from "@/pages/NotFound";
import ScanStart from "@/pages/scan/start/page";
import ScanCamera from "@/pages/scan/camera/page";
import ScanOutput from "@/pages/scan/output/page";
import ScanAnalyzing from "@/pages/scan/analyzing/page";
import ScanResult from "@/pages/scan/result/page";
import ScanResultText from "@/pages/scan/result-text/page";
import ScanResultVideo from "@/pages/scan/result-video/page";
import LessonHub from "@/pages/lesson/hub/page";
import SubjectHub from "@/pages/subject/page";
import TopicPage from "@/pages/topic/page";
import LoginPage from "@/pages/auth/login/page";
import SignupPage from "@/pages/auth/signup/page";
import ForgotPasswordPage from "@/pages/auth/forgot-password/page";
import ResetPasswordPage from "@/pages/auth/reset-password/page";
import PremiumPage from "@/pages/profile/premium/page";
import AboutPage from "@/pages/public/AboutPage";
import ContactPage from "@/pages/public/ContactPage";
import PrivacyPolicyPage from "@/pages/public/PrivacyPolicyPage";
import TermsOfServicePage from "@/pages/public/TermsOfServicePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { path: "/about", element: <AboutPage /> },
      { path: "/contact", element: <ContactPage /> },
      { path: "/terms", element: <TermsOfServicePage /> },
      { path: "/privacy", element: <PrivacyPolicyPage /> },
      {
        path: "/",
        element: <TabRouteWrapper />,
      },
      {
        path: "/history",
        element: <TabRouteWrapper />,
      },
      {
        path: "/ai-assistant",
        element: <TabRouteWrapper />,
      },
      {
        path: "/profile",
        element: <TabRouteWrapper />,
      },
      {
        path: "/profile/premium",
        element: <PremiumPage />,
      },
      {
        path: "/scan/start",
        element: <ScanStart />,
      },
      {
        path: "/scan/camera",
        element: <ScanCamera />,
      },
      {
        path: "/scan/analyzing",
        element: <ScanAnalyzing />,
      },
      {
        path: "/scan/result",
        element: <ScanResult />,
      },
      {
        path: "/scan/output",
        element: <ScanOutput />,
      },
      {
        path: "/scan/result-text",
        element: <ScanResultText />,
      },
      {
        path: "/scan/result-video",
        element: <ScanResultVideo />,
      },
      {
        path: "/lesson/:id",
        element: <LessonHub />,
      },
      {
        path: "/subject/:id",
        element: <SubjectHub />,
      },
      {
        path: "/topic/:id",
        element: <TopicPage />,
      },
    ],
  },
  {
    path: "/auth/login",
    element: <LoginPage />,
  },
  {
    path: "/auth/signup",
    element: <SignupPage />,
  },
  {
    path: "/auth/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/auth/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;